import { getPortalSdkUrl } from "@jari-tools/shared";

export function loadPortalSdk(url = getPortalSdkUrl()): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${url}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Portal SDK laden mislukt"));
    document.head.appendChild(script);
  });
}
